import { Injectable } from '@angular/core';
import * as JSRSAsign from 'jsrsasign';
import { CognitoAcceptFieldInterface } from './interfaces';
import { environment } from '@env/environment';
import { CookieKeys } from '../keys';
import { CookiesService } from '../services/cookies/cookies.service';
@Injectable()
export class AuthUtilityService {
  constructor(private cookiesService: CookiesService) {}

  encrypt(plainText: string, key: string) {
    const publicKey = this._getPublicKey(key);
    // @ts-ignore
    return JSRSAsign.KJUR.crypto.Cipher.encrypt(plainText, publicKey);
  }

  validateCognitoKeys(idTokenString: string, keys: any[]) {
    const header = this._extractHeader(idTokenString);
    const key = this._findMatchingKey(keys, header!);
    const acceptField: CognitoAcceptFieldInterface = {
      alg: environment.aws.cognito.alg,
      iss: environment.aws.cognito.iss,
    };
    // @ts-ignore
    return JSRSAsign.jws.JWS.verifyJWT(
      idTokenString,
      JSRSAsign.KEYUTIL.getKey(key),
      acceptField,
    );
  }

  extractBody(jwt: string) {
    const a = jwt.split('.');
    // @ts-ignore
    const body = JSRSAsign.jws.JWS.readSafeJSONString(
      JSRSAsign.b64utoutf8(a[1]),
    );

    return body;
  }

  async getToken(): Promise<string> {
    const cookies = await this.cookiesService.getCookies();
    const token = cookies[CookieKeys.HE_AUTH_TOKEN];
    if (token?.startsWith(`"`)) {
      return token.slice(1, -1);
    }
    return token;
  }

  async setToken(token: string) {
    this.cookiesService.setCookie(CookieKeys.HE_AUTH_TOKEN, token);
  }

  private _getPublicKey(key: any) {
    return JSRSAsign.KEYUTIL.getKey(key);
  }

  private _extractHeader(jwt: string) {
    const a = jwt.split('.');
    const pHeader = JSRSAsign.KJUR.jws.JWS.readSafeJSONString(
      JSRSAsign.b64utoutf8(a[0]),
    );

    return pHeader;
  }

  private _findMatchingKey(keys: any[], header: Record<string, any>) {
    for (let i = 0; i < keys.length; ++i) {
      const key = keys[i];
      if (key.kid === header.kid) {
        return key;
      }
    }

    return null;
  }
}
